export default __webpack_public_path__ + "static/media/error_internet.2c40959d.svg";